import React, { Suspense } from 'react';
import { ThemeProvider } from 'fronton-react';
import { CssBaseline, notificationTemplateFactory } from 'common/components';
import { Banner } from 'features/banner';
import { BannerFeatureProps, StretchBannerFeatureProps } from 'features/banner/types';
import { StretchBanner } from 'features/stretch-banner';
import { NotificationList } from '@navi-toolbox/ui-components';
import { useClientBreakpoint } from 'common/hooks/use-client-breakpoint';

export const BannerWidget: React.FC<BannerFeatureProps & StretchBannerFeatureProps> = ({ ...props }) => {
  const isMobileDevice = useClientBreakpoint(bp => bp.atMobile);

  return (
    <Suspense>
      <ThemeProvider>
        <CssBaseline />
        {props.fullWidth ? <StretchBanner {...props} /> : <Banner {...props} />}
        <NotificationList isDesktop={!isMobileDevice} templateFactory={notificationTemplateFactory} />
      </ThemeProvider>
    </Suspense>
  );
};
